import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

const rotateClockwise = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const rotateCounterClockwise = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
`;

const StyledSvg = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Ring = styled.path`
  transform-origin: center;
`;

const Ring1 = styled(Ring)`
  animation: ${rotateClockwise} 1.5s linear infinite;
`;

const Ring2 = styled(Ring)`
  animation: ${rotateCounterClockwise} 1.5s linear infinite;
`;

const Ring3 = styled(Ring)`
  animation: ${rotateClockwise} 1.5s linear infinite;
`;

const Ring4 = styled(Ring)`
  animation: ${rotateCounterClockwise} 1.5s linear infinite;
`;

const AnimatedSpinner = ({ className = null, size = 24 }) => (
  <StyledSvg className={className}>
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='logo'>
        <g clipPath='url(#clip0_15_15)'>
          <Ring1
            id='ring1'
            d='M1.94063 16.4507C0.878348 14.0498 0.709829 11.3481 1.46552 8.83381C2.22121 6.31949 3.85126 4.15838 6.06117 2.74093C8.27108 1.32348 10.9151 0.743183 13.5155 1.10489C16.1159 1.46659 18.5011 2.74644 20.2403 4.71319C21.9795 6.67995 22.9579 9.20389 22.9987 11.829C23.0395 14.4541 22.14 17.0072 20.4628 19.0271C18.7856 21.047 16.4413 22.4004 13.8534 22.8427C11.2655 23.2851 8.60478 22.7873 6.35188 21.4392'
            stroke='#E56000'
            strokeOpacity='0.2'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <Ring2
            id='ring2'
            d='M19.5303 9.29917C20.0765 10.822 20.1481 12.4746 19.7358 14.039C19.3234 15.6034 18.4465 17.006 17.2206 18.0617C15.9948 19.1175 14.4777 19.7768 12.8694 19.9526C11.2612 20.1284 9.63748 19.8125 8.21247 19.0466C6.78746 18.2807 5.62816 17.1007 4.88753 15.6624C4.1469 14.2241 3.85975 12.595 4.06397 10.9901C4.26819 9.38527 4.95418 7.88003 6.03143 6.67303C7.10868 5.46604 8.52656 4.61401 10.098 4.22938'
            stroke='#E56000'
            strokeOpacity='0.4'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <Ring3
            id='ring3'
            d='M16.1476 9.20759C16.6225 9.91294 16.9096 10.7277 16.9819 11.575C17.0542 12.4222 16.9092 13.2739 16.5607 14.0495C16.2121 14.8251 15.6715 15.499 14.99 16.0074C14.3085 16.5159 13.5086 16.8422 12.6658 16.9554C11.8231 17.0687 10.9654 16.9651 10.1738 16.6545C9.38227 16.344 8.68298 15.8367 8.14208 15.1806C7.60117 14.5245 7.23653 13.7413 7.08261 12.9051C6.92869 12.0688 6.99058 11.2071 7.26243 10.4014'
            stroke='#E56000'
            strokeOpacity='0.6'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <Ring4
            id='ring4'
            d='M13.3906 13.4374C13.1611 13.6595 12.8817 13.8234 12.5758 13.9153C12.2699 14.0073 11.9464 14.0246 11.6325 13.9659C11.3185 13.9072 11.0231 13.7742 10.7711 13.5779C10.5191 13.3817 10.3178 13.1279 10.184 12.8379C10.0502 12.5479 9.98775 12.23 10.002 11.9109C10.0162 11.5918 10.1066 11.2808 10.2657 11.0038C10.4248 10.7269 10.6479 10.492 10.9164 10.319C11.1849 10.1459 11.4909 10.0397 11.8088 10.0092'
            stroke='#E56000'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_15_15'>
          <rect width='24' height='24' rx='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  </StyledSvg>
);

AnimatedSpinner.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number
};

export { AnimatedSpinner };
